import { createRouter, createWebHistory } from 'vue-router'
import { appRoutes } from './app-routes'
import { authRoutes } from './auth-routes'
import { exportRoutes } from './export-routes'
import { masterRoutes } from './master-routes'
import { microfinanceRoutes } from './microfinance-routes'
import { shopRoutes } from './shop-routes'

const rootRoute = {
  path: '/',
  component: () => import('@/layouts/app/layout-app.vue'),
  children: [
    ...(appRoutes[0]?.children || []),
    ...(shopRoutes[0]?.children || []),
    ...(masterRoutes[0]?.children || []),
    ...(microfinanceRoutes[0]?.children || []),
  ],
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...authRoutes,
    rootRoute,
    ...exportRoutes,
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: () => import('@/views/error/page-unauthorized.vue'),
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('@/views/error/page-error.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not found',
      component: () => import('@/views/error/page-not-found.vue'),
    },
  ],
  linkExactActiveClass: 'link-exact-active',
  linkActiveClass: 'link-active',
})

import { useAuthStore } from '@/stores/auth'

const routePermissionMap: Record<string, string> = {
  'loan list': 'melihat list pinjaman',
  'loan type list': 'melihat tipe pinjaman',
  'loan payment list': 'melihat list pembayaran pinjaman',
  'loan topup list': 'melihat list topup pinjaman',
  'saving list': 'melihat list simpanan',
  'saving type list': 'mengelola tipe simpanan',
  'product category list': 'melihat list kategori produk',
  'product list': 'melihat list produk',
  'supplier list': 'melihat list supplier',
  'user list': 'melihat list pengguna',
  'role list': 'melihat list peran',
  'payment method list': 'melihat list metode pembayaran',
  'salary deduction list': 'melihat list potongan gaji',
  'announcement list': 'melihat list pengumuman',
  'announcement create': 'menambah pengumuman',
  'announcement edit': 'mengedit pengumuman',
  'loan self': 'menambah pinjaman (sendiri)',
  'loan topup self': 'menambah topup pinjaman (sendiri)',
  'saving withdrawal self': 'menambah penarikan simpanan',
}

router.beforeEach((to, from, next) => {
  const auth = useAuthStore()

  const errorRoutes = ['unauthorized', 'error', 'not found', 'login']
  if (from && from.name && !errorRoutes.includes(from.name as string)) {
    sessionStorage.setItem('last_route', JSON.stringify({
      name: from.name,
      params: from.params,
      query: from.query,
    }))
  }

  if (auth.user && auth.user.id) {
    const isAdmin = auth.can('mengakses halaman admin') || auth.user?.role === 'superadmin'

    if (isAdmin && (to.path === '/mobile' || to.path.startsWith('/mobile/'))) {
      return next({ name: 'dashboard' })
    }

    if (to.name === 'dashboard') {
      if (!isAdmin) {
        return next({ name: 'mobile home' })
      }
    }

    const routeName = to.name as string
    const requiredPermission = routePermissionMap[routeName]
    const isSuperadmin = auth.user?.role?.toLowerCase() === 'superadmin'
    if (requiredPermission && !isSuperadmin) {
      let hasPermission = auth.can(requiredPermission)
      if (routeName === 'loan self' && auth.can('menambah pinjaman')) {
        hasPermission = true
      }
      if (routeName === 'loan topup self' && auth.can('menambah topup pinjaman')) {
        hasPermission = true
      }
      if (!hasPermission) {
        return next({ name: 'unauthorized' })
      }
    }
  }

  next()
})

export default router
